<template>
  <div class="stipulations-template" theme>
    <div id="theme-registration-stipulations" />
  </div>
</template>

<script>
export default {
  data() {
    return {
      path: 'registration',
      parts: [
        {
          elem: '#theme-registration-stipulations',
          htmlFile: 'stipulation'
        }
      ]
    }
  },
  mounted() {
    if (this.loggedInUser) {
      this.openLink('/')
    }
    window.setCookie('agreedStipulations', [])
    window.setCookie('disagreedStipulations', [])
  }
}
</script>
